import { Container, Row, Col, Button, Image, Stack } from "react-bootstrap";
import { FaRobot, FaDatabase, FaChartBar } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { MdPrivacyTip } from "react-icons/md";
import { Helmet } from 	"react-helmet-async";
import ScrollAnimationWrapper from "../components/Other/ScrollAnimationWrapper";

const Solutions = () => {
  return (
    <Stack className="px-4" style={{overflow:'hidden'}}>
		<Helmet>
			<title>Solutions - QuickyChat</title>
			<meta name="description" content="Discover how QuickyChat's AI chatbots can resolve 70-80% of customer queries autonomously. Automate customer support at scale with our AI-powered platform." />
			<meta name="keywords" content="AI chatbot, customer support, automation, AI-powered chatbots, QuickyChat" />
		</Helmet>
      {/* Header Section */}
        <Container className="py-5">
			<Row className="align-items-center">
				<Col md={6}>
				<ScrollAnimationWrapper>
					<h1 className="mb-3">AI Chatbots can Resolve 70-80% of Customer Queries Autonomously!</h1>
					<p className="mb-4">
						Automate customer support at scale with AI-powered chatbots designed for FAQs, complex queries, and live agent assistance 24/7.
					</p>
					<div className="mb-4">
						<Link to="/dashboard">
							<Button 
								className="mb-2"
								variant="primary" 
								size="lg"
								style={{marginRight:'1em'}}>
								Get Started for Free
							</Button>
						</Link>
						<Link to="/demo">
							<Button variant="outline-light" size="lg">See Demo</Button>
						</Link>
					</div>
					</ScrollAnimationWrapper>
				</Col>
				<Col md={6} className="text-center">
					<ScrollAnimationWrapper>
						<Image 
							src="/images/chatbot-1.png" 
							className="rounded shadow-lg justify-self-center" 
							style={{
								width: '100%',
								maxWidth: '300px',
								height: 'auto'
							}}/>
					</ScrollAnimationWrapper>
				</Col>
			</Row>
			
        </Container>

      {/* Features Section */}
        <Container className="text-white p-5 rounded mb-4" style={{ backgroundColor: '#2d2d2d' }}>
			<ScrollAnimationWrapper>
			<div className="justify-self-center mb-4" style={{maxWidth:'600px'}}>
				<h2 className="text-center mb-4">Why choose our AI chatbot platform?</h2>
				<p className="text-center" >
					We make building and deploying chatbots an effortless experience. 
					Say goodbye to complicated processes. Our intuitive platform allows you to 
					create and launch your chatbot in no time, saving you valuable resources and effort.
				</p>
			</div>
			</ScrollAnimationWrapper>

			<Row>
				<Col md={3} className="text-center mb-4">
					<ScrollAnimationWrapper>
						<FaDatabase size={40} className="mb-3" />
						<h5>Custom Knowledge Base</h5>
						<p>Build and manage your chatbot's knowledge base to resolve customer queries efficiently.</p>
					</ScrollAnimationWrapper>
				</Col>
				<Col md={3} className="text-center mb-4">
					<ScrollAnimationWrapper>
						<FaRobot size={40} className="mb-3" />
						<h5>Advanced AI Tools</h5>
						<p>
							Our tools are designed to deliver smart, human-like interactions that elevate the user experience.
						</p>
					</ScrollAnimationWrapper>
				</Col>
				<Col md={3} className="text-center mb-4">
					<ScrollAnimationWrapper>
						<FaChartBar size={40} className="mb-3" />
						<h5>Marketing Analysis Made Easy</h5>
						<p>
							Track chat interactions, monitor user behavior, and visualize data with dynamic performance graphs.
						</p>
					</ScrollAnimationWrapper>
				</Col>
				<Col md={3} className="text-center mb-4">
					<ScrollAnimationWrapper>
						<MdPrivacyTip size={40} className="mb-3" />
						<h5>Privacy & Security</h5>
						<p>Ensure customer data is secure and compliant with industry standards.</p>
					</ScrollAnimationWrapper>
				</Col>
			</Row>
        </Container>

        <Container>
          {/* <h2 className="text-center mb-4">Resolve complex questions with a finely tuned knowledge base</h2>
          <p className="text-center mb-5">Pair your business data with any LLM.</p>
          <Row>
            <Col md={4} className="text-center mb-4">
              <FaExpand size={40} className="mb-3" />
              <h5>Scalable Vector Database</h5>
              <p>Scale your knowledge base to thousands of data sources with a scalable vector database.</p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <FaCog size={40} className="mb-3" />
              <h5>Multi-LLM Support</h5>
              <p>Power knowledge base responses with the latest LLM models.</p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <FaSearch size={40} className="mb-3" />
              <h5>Search and Manage</h5>
              <p>Manage large amounts of data sources with a knowledge base CMS.</p>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="text-center mb-4">
              <FaBolt size={40} className="mb-3" />
              <h5>Use Data to Perform Actions</h5>
              <p>Give your agent the ability to ask the knowledge base for data to perform advanced actions.</p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <FaCog size={40} className="mb-3" />
              <h5>Tweak LLM Settings</h5>
              <p>Tweak your knowledge base responses by changing the LLM model, temperature, and more.</p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <FaSearch size={40} className="mb-3" />
              <h5>Instant Previews</h5>
              <p>Preview and tweak your knowledge base answers instantly with 1:1 prototypes.</p>
            </Col>
          </Row> */}
        </Container>

		{/* Call to Action */}
		<Row className="text-center py-5">
			<Col>
				<ScrollAnimationWrapper>
					<h3 className="mb-3">Ready to Get Started?</h3>
					<p>
						Sign up today and begin creating intelligent, customized AI chatbots that work for you.
					</p>
					<Link to="/dashboard">
						<Button variant="primary" size="lg">
							Start Building for Free
						</Button>
					</Link>
				</ScrollAnimationWrapper>
			</Col>
		</Row>
    </Stack>
  );
};

export default Solutions;
